import script from "./SafetyHistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./SafetyHistoryView.vue?vue&type=script&setup=true&lang=js"

import "./SafetyHistoryView.vue?vue&type=style&index=0&id=709d9329&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709d9329"]])

export default __exports__